import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormContext } from "react-hook-form";
import * as S from "../../cmsForm.style";
import { ErrorMessage } from "../ErrorMessage/errorMessage";
export var CustomRadio = function(_param) {
    var name = _param.name, label = _param.label, options = _param.options, isColMiddle = _param.isColMiddle, isHidden = _param.isHidden, isDisabled = _param.isDisabled, isPendingRequest = _param.isPendingRequest, props = _object_without_properties(_param, [
        "name",
        "label",
        "options",
        "isColMiddle",
        "isHidden",
        "isDisabled",
        "isPendingRequest"
    ]);
    var ref;
    var ref1 = useFormContext(), register = ref1.register, errors = ref1.formState.errors;
    var error = (ref = errors[name]) === null || ref === void 0 ? void 0 : ref.message;
    return /*#__PURE__*/ _jsxs(S.StyledInputContainer, {
        isColMiddle: isColMiddle,
        isHidden: isHidden,
        children: [
            /*#__PURE__*/ _jsxs(S.StyledRadioGroup, {
                children: [
                    /*#__PURE__*/ _jsx("label", {
                        className: "label",
                        children: label
                    }),
                    /*#__PURE__*/ _jsx("section", {
                        children: options && options.map(function(param) {
                            var description = param.description, value = param.value;
                            return /*#__PURE__*/ _jsxs("label", {
                                className: "options",
                                children: [
                                    /*#__PURE__*/ _jsx("input", _object_spread_props(_object_spread({}, register(name), props), {
                                        value: value,
                                        type: "radio",
                                        disabled: isDisabled || isPendingRequest
                                    })),
                                    /*#__PURE__*/ _jsx("span", {
                                        children: description
                                    })
                                ]
                            }, value);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ErrorMessage, {
                error: error
            })
        ]
    });
};
